import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeferLoadDirective } from './defer-load.directive';
import { WindowHeightDirective } from './window-height.directive';
import { CountryValidatorDirective } from './country-validator.directive';
import { ImageErrorHandlerDirective } from './image-error-handler.directive';

@NgModule({
  declarations: [DeferLoadDirective, WindowHeightDirective, CountryValidatorDirective, ImageErrorHandlerDirective],
  imports: [CommonModule],
  exports: [DeferLoadDirective, WindowHeightDirective, CountryValidatorDirective, ImageErrorHandlerDirective],
  providers: [ImageErrorHandlerDirective],
})
export class DirectivesModule {}
